import { RADAR_URN } from "@Constants/radarUrn";
import { useForecastAppContext } from "@Context/ForecastAppContext/ForecastAppContext";
import { useTranslations } from "@Context/TranslationContext/TranslationContext";
import { Image, MeteoMapsService } from "@MeteoMapsApi/index";
import radarTeaserFallback from "@Resources/images/iconsets/srf_radar_teaser_fallback.png";
import { useEffect, useState } from "react";
import { useDarkMode } from "usehooks-ts";

export const RadarTeaser = () => {
  const { isDarkMode } = useDarkMode();
  const { env } = useForecastAppContext();
  const { t } = useTranslations();
  const [teaserImages, setTeaserImages] = useState<Image>({
    dark: "",
    light: "",
  });

  useEffect(() => {
    const fetchTeaserImage = async () => {
      try {
        const radarMapgroup = await MeteoMapsService.getMapgroup({
          mapgroupUrn: RADAR_URN[env],
        });

        setTeaserImages({
          dark: radarMapgroup?.teaser?.image?.dark ?? "",
          light: radarMapgroup?.teaser?.image?.light ?? "",
        });
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error("Error fetching teaser image:", error);
      }
    };

    fetchTeaserImage();
  }, [env]);
  return (
    <div className="m:flex m:min-h-[190px] m:items-center m:justify-center m:lg:min-h-[150px] m:xl:min-h-[190px]">
      <div className="m:relative m:mb-4 m:flex m:items-center m:justify-center m:rounded-sm">
        <picture className="m:absolute m:-z-10">
          <source
            srcSet={teaserImages.dark}
            media="(prefers-color-scheme: dark)"
            className={!isDarkMode ? "m:hidden" : ""}
          />
          <source
            srcSet={teaserImages.light}
            media="(prefers-color-scheme: light)"
            title={t("teaser.radar")}
          />
          <img
            src={radarTeaserFallback}
            alt={t("teaser.radar")}
            loading="lazy"
            className="m:m-auto m:h-[347px]! m:w-full! m:min-w-[280px]! m:object-scale-down"
          />
        </picture>
      </div>
    </div>
  );
};
